var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.4,687.4v118.9h144V687.4H431.4z M500,990C229.4,990,10,770.6,10,500S229.4,10,500,10c270.6,0,490,219.4,490,490S770.6,990,500,990z M351.2,225c-60.2,32.6-92.3,88-96.2,166.2h139.7c0-22.8,7.8-44.7,23.4-65.8c15.6-21.1,42.1-31.7,79.5-31.7c38,0,64.2,8.6,78.5,25.7s21.5,36.1,21.5,57c0,18.1-6.4,34.7-19.3,49.8l-28,24.3L515,473.9c-34.8,23-56.4,43.4-64.8,61.1c-8.4,17.7-13.5,49.7-15.5,96.1h130.5c0.3-21.9,2.4-38.1,6.3-48.5c6.1-16.5,18.5-30.9,37.2-43.2l34.3-22.6c34.8-23,58.3-42,70.6-56.8c20.9-24.4,31.4-54.4,31.4-90.1c0-58.1-24.1-102-72.2-131.6c-48.2-29.6-108.6-44.4-181.5-44.4C435.9,193.8,389.2,204.2,351.2,225z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmark);
export default __webpack_public_path__ + "static/media/questionmark.52865611536569e6665069ac49cf99a1.svg";
export { ForwardRef as ReactComponent };